import { Navigation } from '@toolpad/core';
import AddIcon from '@mui/icons-material/Add';
import ArticleIcon from '@mui/icons-material/Article';
import HailIcon from '@mui/icons-material/Hail';
import LoginIcon from '@mui/icons-material/Login';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import WorkIcon from '@mui/icons-material/Work';
import DiscountIcon from '@mui/icons-material/Discount';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import CampaignIcon from '@mui/icons-material/Campaign';
import RoofingIcon from '@mui/icons-material/Roofing';
import FeedIcon from '@mui/icons-material/Feed';
import ContactPageIcon from '@mui/icons-material/ContactPage';

import { AuthRole } from '@libs/types';
import { PostRequestNotification } from '@carcareers/components';

export const baseRouteNavigation: Navigation = [
  { kind: 'header', title: 'Job Seekers' },
  {
    kind: 'page',
    segment: 'sign-in',
    title: 'Job Seeker Sign In',
    icon: <LoginIcon />,
  },
  {
    kind: 'page',
    segment: 'register/jobseeker',
    title: 'Job Seeker Register',
    icon: <HailIcon />,
  },
  { kind: 'header', title: 'Employers' },
  {
    kind: 'page',
    segment: 'employers',
    title: 'Learn More',
    icon: <MenuBookIcon />,
  },
  {
    kind: 'page',
    segment: 'sign-in',
    title: 'Employer Sign In',
    icon: <LoginIcon />,
  },
  {
    kind: 'page',
    segment: 'register/employer',
    title: 'Employer Register',
    icon: <CorporateFareIcon />,
  },
];

export const jobseekerRouteNavigation: Navigation = [];

export const employerRouteNavigation: Navigation = [
  { kind: 'header', title: 'Employer Dashboard' },
  {
    segment: 'employer/post-a-job',
    title: 'Post a Job',
    icon: <AddIcon />,
    pattern: 'employer/post-a-job',
  },
  {
    segment: 'employer/rooftops',
    title: 'Rooftops',
    icon: <RoofingIcon />,
    pattern: 'employer/rooftops{/:id}*',
  },
  {
    segment: 'employer/templates',
    title: 'My Job Templates',
    icon: <ArticleIcon />,
    pattern: 'employer/templates{/:id}*',
  },
  {
    segment: 'employer/jobs',
    title: 'Jobs',
    icon: <WorkIcon />,
    pattern: 'employer/jobs{/:id}*',
  },
  {
    segment: 'employer/candidates',
    title: 'Candidates',
    icon: <HailIcon />,
    pattern: 'employer/candidates{/:id}*',
  },
  { kind: 'divider' },
  {
    kind: 'header',
    title: 'Tutorial',
  },
  {
    segment: 'employer/tutorial/post-a-job',
    title: 'Post a Job',
  },
  {
    segment: 'employer/tutorial/request-a-recruiter',
    title: 'Request a Recruiter',
  },
  {
    segment: 'employer/tutorial/manage-candidates',
    title: 'Manage Candidates',
  },
];

export const adminRouteNavigation: Navigation = [
  { kind: 'header', title: 'Job Management' },
  {
    segment: 'admin/jobs/add',
    title: 'Post a Job',
    icon: <AddIcon />,
    pattern: 'admin/jobs/add{/:id}*',
  },
  {
    segment: 'admin/requests',
    title: 'Job Requests',
    icon: <FeedIcon />,
    pattern: 'admin/requests{/:id}*',
    action: <PostRequestNotification />,
  },
  {
    segment: 'admin/contact-requests',
    title: 'Contact Requests',
    icon: <ContactPageIcon />,
    pattern: 'admin/contact-requests{/:id}*',
  },
  {
    segment: 'admin/templates',
    title: 'Templates',
    icon: <WorkIcon />,
    pattern: 'admin/templates{/:id}*',
  },
  {
    segment: 'admin/jobs',
    title: 'Jobs',
    icon: <FeedIcon />,
    pattern: 'admin/jobs{/:id}*',
  },
  { kind: 'divider' },
  { kind: 'header', title: 'User Management' },
  {
    segment: 'admin/employers',
    title: 'Employers',
    icon: <CorporateFareIcon />,
    pattern: 'admin/employers{/:id}*',
  },
  {
    segment: 'admin/jobseekers',
    title: 'Job Seekers',
    icon: <HailIcon />,
    pattern: 'admin/jobseekers{/:id}*',
  },
  {
    segment: 'admin/rooftops',
    title: 'Rooftops',
    icon: <RoofingIcon />,
    pattern: 'admin/rooftops{/:id}*',
  },
  {
    segment: 'admin/resumes',
    title: 'Resumes',
    icon: <ArticleIcon />,
    pattern: 'admin/resumes{/:id}*',
  },
  { kind: 'divider' },
  { kind: 'header', title: 'Revenue Management' },
  {
    segment: 'admin/campaigns',
    title: 'Campaigns',
    icon: <CampaignIcon />,
    pattern: 'admin/campaigns{/:id}*',
  },
  {
    segment: 'admin/promos',
    title: 'Promo Codes',
    icon: <DiscountIcon />,
    pattern: 'admin/promos{/:id}*',
  },
];

export const navigation: Record<AuthRole | 'default', Navigation> = {
  default: baseRouteNavigation,
  [AuthRole.JOBSEEKER]: jobseekerRouteNavigation,
  [AuthRole.EMPLOYER]: employerRouteNavigation,
  [AuthRole.ADMIN]: adminRouteNavigation,
  [AuthRole.SELF]: baseRouteNavigation,
};
